
import Vue from "vue";
import { mapGetters } from "vuex";
import LanguageList from "@/components/menu-view/menu-language-list.vue";
import PowerByVacanFrame from "@/layouts/power-by-vacan-frame.vue";
import GeneralHeader from "@/components/general-header.vue";

export default Vue.extend({
  name: "component-menu-language-prompt",
  components: { PowerByVacanFrame, LanguageList, GeneralHeader },
  computed: {
    ...mapGetters("ui", ["isMobile"]),
  },
  methods: {
    rowClicked(language: "en-US" | "zh-TW" | "zh-CN" | "ja-JP" | "ko-KR") {
      this.$i18n.locale = language;
      this.$store.commit("data/setLanguage", language);
      this.$emit("language-clicked", language);
    },
    closeView() {
      this.$emit("close-view");
    },
  },
});
